<script>
    import Modal from '../components/modal/Modal.svelte';
    import Notifier from "../stores/notifier";
    import {dateAfter, setFocusTo} from "../lib/lib";

    export let name = '';
    export let subscription = null;
    export let closeCallback;

    let modalTitle = 'Συνδρομή Μέλους';

    const onStartChange = () => {
        if (!subscription.end_year || subscription.end_year < subscription.start_year) {
            subscription.end_year = subscription.start_year;
        }
    }

    const save = () => {

        if (!subscription.start_year) {
            Notifier.showError("Επιλέξτε έτος έναρξης συνδρομής.");
            setFocusTo("startYear");
            return;
        }

        if (!subscription.end_year) {
            Notifier.showError("Επιλέξτε έτος λήξης συνδρομής.");
            setFocusTo("endYear");
            return;
        }

        if (subscription.start_year > subscription.end_year) {
            Notifier.showError("Το έτος λήξης δεν είναι έγκυρο.");
            setFocusTo("endYear");
            return;
        }

        if (!subscription.date_at) {
            Notifier.showError("Η ημερομηνία ανανέωσης δεν είναι έγκυρη.");
            setFocusTo("dateAt");
            return;
        }

        close(subscription);
    }

    const close = (param) => {
        subscription = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    if (subscription.action) {
        if (subscription.action === 'add') {
            modalTitle = "Νέα συνδρομή";
        } else if (subscription.action === 'renew') {
            modalTitle = 'Ανανέωση συνδρομής';
        }
    }

    subscription.start_year = ~~subscription.start_year;
    subscription.end_year = ~~subscription.end_year;
</script>
{#if subscription}
    <Modal title="{ modalTitle } { name }" on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class="col-3 form-group">
                    <label>Έναρξη</label>
                    <input type="number" class="form-control" id="startYear" bind:value="{ subscription.start_year }"
                           on:change={ onStartChange }>
                </div>
                <div class="col-3 form-group">
                    <label>Λήξη</label>
                    <input type="number" class="form-control" id="endYear" bind:value="{ subscription.end_year }">
                </div>
                <div class="col-6 form-group">
                    <label>Ημ. Ανανέωσης</label>
                    <input type="date" class="form-control" id="dateAt" bind:value="{ subscription.date_at }">
                </div>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">OK</button>
            </div>
        </div>
    </Modal>
{/if}